import { FormControl, MenuItem, Select, SelectChangeEvent, Typography } from "@mui/material";

interface SelectAggregationProps {
    aggregation: string;
    onChange: (newAggregation: string) => void;
}


export default function SelectAggregation({ aggregation, onChange } : SelectAggregationProps) {
    const access = localStorage.getItem("access");
    
    // Determine if user has premium access
    const hasPremiumAccess = access && access !== 'null' && access !== 'free';
    
    // Get effective aggregation value - fallback to 'hour' if current value is not available
    const getEffectiveAggregation = () => {
        if (aggregation === 'none' && !hasPremiumAccess) {
            return 'hour';
        }
        if (aggregation === 'year' && !hasPremiumAccess) {
            return 'hour';
        }
        return aggregation;
    };
    
    const effectiveAggregation = getEffectiveAggregation();
    
    const handleChange = (event: SelectChangeEvent) => {
        onChange(event.target.value as string);
      };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
            <Typography variant="h6" gutterBottom>
                Time period
            </Typography>
            <FormControl sx={{ width: '150px' }}>
                <Select
                    id="demo-simple-select"
                    value={effectiveAggregation}
                    onChange={handleChange}
                    sx={{ fontSize: '14px' }}
                >
                    {access && access !== 'null' && access !== 'free' && <MenuItem value={'none'}>30 Minute</MenuItem>}
                    <MenuItem value={'hour'}>1 Hour</MenuItem>
                    <MenuItem value={'day'}>Day</MenuItem>
                    <MenuItem value={'week'}>Week</MenuItem>
                    <MenuItem value={'month'}>Month</MenuItem>
                    {access && access !== 'null' && access !== 'free' && <MenuItem value={'year'}>Year</MenuItem>}
                </Select>
            </FormControl>
        </div>
    )
}